import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    class: "btn btn-primary btn-sm",
    title: "Cadastrar"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-plus-circle-fill" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
    ]),
    _: 1,
    __: [0]
  }, 8, ["to"]))
}